<template>
  <Page title="Daftar Asset" :sidebar="true">
    <Sidebar :value.sync="asset" :rebind="rebind" @add-asset="AddAsset" />
    <aset-gedung :forms="forms" @save="Save"></aset-gedung>
    <aset-jalan :forms="forms" @save="Save"></aset-jalan>
  </Page>
</template>
<script>
import AsetGedung from './AsetGedung.vue'
import AsetJalan from './AsetJalan.vue'
import Sidebar from './Sidebar.vue'
export default {
  components: {
    Sidebar,
    AsetGedung,
    AsetJalan,
  },
  data: () => ({
    forms: {},
    asset: {},
    doPrint: 0,
    rebind: 0,
  }),
  watch: {
    asset(val) {
      this.forms = val
    },
  },
  mounted() {
    this.$api.Authorize()
  },
  methods: {
    async Save(forms) {
      let ret = await this.$api.call('AST.SavAsset', forms)
      if (ret.success) {
        this.rebind++
        this.forms = { AssetId: ret.data[0].Id }
      }
    },
    AddAsset(item) {
      this.forms = {
        AssetId: 0,
        ...item,
      }
    },
  },
}
</script>
<style lang="scss">
.page-daftar-asset {
  .--input,
  textarea {
    width: 500px !important;
  }
}
@media only screen and (max-device-width: 480px) {
  .page-daftar-asset {
    .--input,
    textarea {
      width: 100% !important;
    }
  }
}
</style>
